import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { WatchlistModalComponent } from "./watchlist-modal/watchlist-modal.component";
import { IconsModule } from "@va/core-library/icons";
import { ButtonModule } from "@va/core-library/button";
import { FormsModule } from "@angular/forms";
import { SharedModule } from "../shared/shared.module";
import { WatchlistSearchAddComponent } from "./watchlist-search-add/watchlist-search-add.component";
import { WatchlistAlertsComponent } from "./watchlist-alerts/watchlist-alerts.component";
import { WatchlistMenuComponent } from "./watchlist-menu/watchlist-menu.component";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { RouterModule } from "@angular/router";
import { WatchlistTickerSearchComponent } from "./watchlist-ticker-search/watchlist-ticker-search.component";
import { NzCheckboxModule } from "ng-zorro-antd/checkbox";
import { NzSkeletonModule } from "ng-zorro-antd/skeleton";
import { NzInputModule } from "ng-zorro-antd/input";
import { NzModalModule } from "ng-zorro-antd/modal";
import { NzSwitchModule } from "ng-zorro-antd/switch";
import { NzTableModule } from "ng-zorro-antd/table";
import { NzSelectModule } from "ng-zorro-antd/select";
import { NzPopoverModule } from "ng-zorro-antd/popover";
import { NzButtonModule } from "ng-zorro-antd/button";
import { NzGridModule } from "ng-zorro-antd/grid";
import { NzToolTipModule } from "ng-zorro-antd/tooltip";
import { NzMenuModule } from "ng-zorro-antd/menu";
@NgModule({
  declarations: [
    WatchlistModalComponent,
    WatchlistSearchAddComponent,
    WatchlistAlertsComponent,
    WatchlistMenuComponent,
    WatchlistTickerSearchComponent,
  ],
  imports: [
    CommonModule,
    IconsModule,
    ButtonModule,
    FormsModule,
    SharedModule,
    MatSnackBarModule,
    NzCheckboxModule,
    NzInputModule,
    NzSkeletonModule,
    NzModalModule,
    NzSwitchModule,
    NzTableModule,
    NzSelectModule,
    NzPopoverModule,
    NzButtonModule,
    NzGridModule,
    NzToolTipModule,
    RouterModule,
    NzMenuModule,
  ],
  exports: [
    WatchlistModalComponent,
    WatchlistMenuComponent,
    WatchlistSearchAddComponent,
  ],
})
export class WatchlistModule {}
